<template>
  <div :class="['bookmarks', { collapsed: !expand, large: largeBookmarks }]">
    <div class="header">
      <span
        @click="expand = !expand; $emit('toggle')"
        :class="['fas expand', { 'fa-angle-double-right': expand, 'fa-angle-double-left': !expand }]"
      ></span>
      <h2 class="title">Bookmarks</h2>
    </div>
    <div class="bookmarks-meta">
      <div class="counts" v-if="!expand">
        <ul>
          <li>Fandoms: {{ bookmarks.length }}</li>
          <li v-if="unlock">Prompts: {{ promptmarks.length }}</li>
        </ul>
      </div>
    </div>
    <div class="content" v-show="expand">
      <div class="options">
        <input type="checkbox" id="expand-bookmarks" v-model="largeBookmarks" />
        <label for="expand-bookmarks">Make this wider</label>
      </div>
      <p v-if="showHelp">
        You can bookmark fandoms, letters, and - when they become available after Madness - individual
        prompts by clicking on the
        <span
          class="far fa-heart"
        ></span> icon. This data is saved in your browser,
        and will remain for as long as you do not clear the cache.
      </p>

      <div class="fandoms">
        <h3>Fandoms</h3>
        <table v-if="bookmarksData.length">
          <thead>
            <tr>
              <th class="fandom">Fandom</th>
              <th class="prompts" v-if="unlock">Prompts</th>
            </tr>
          </thead>
          <tr
            v-for="(fandom, index) in bookmarksData"
            :class="{ odd: index % 2 !== 0 }"
            :key="fandom.name"
          >
            <td class="fandom">
              {{ fandom.name }}
              <span @click="remove(fandom)" class="remove far fa-times-circle"></span>
            </td>

            <td v-if="unlock" class="prompts">
              <button
                class="button-primary"
                v-if="!prompts[fandom.key] && hasPrompts[fandom.key]"
                @click="getPrompts( fandom.key)"
              >Get Prompts</button>
              <div v-if="prompts[fandom.key] === 'loading'">Loading...</div>
              <template
                v-if="prompts[fandom.key] && prompts[fandom.key].length && prompts[fandom.key] !== 'loading'"
              >
                <a
                  href="javascript:void(0);"
                  @click="collapse(prompts[fandom.key].length, $event)"
                >Collapse</a>
                <Prompts :prompts="prompts[fandom.key]"></Prompts>
              </template>
              <span v-if="!hasPrompts[fandom.key]">No prompts ):</span>
            </td>
          </tr>
        </table>
        <span v-else>You haven't bookmarked any fandoms yet ):</span>
      </div>

      <template v-if="unlock">
        <hr />
        <h3>Prompts</h3>

        <div v-if="promptmarks.length">
          <strong>Prompts:</strong>

          <Prompts :prompts="promptmarks"></Prompts>
        </div>
        <span v-else>You haven't bookmarked any prompts yet ):</span>
      </template>
    </div>
  </div>
</template>

<script>
import { find } from "lodash";
import { mapGetters } from "vuex";
import utils from "./utils.js";
import Prompts from "./table/prompts.vue";
export default {
  components: { Prompts },
  beforeMount() {
    const data = [];
    find(this.bookmarks, o => {
      const fandom = find(this.fandoms, fandom => {
        return fandom.name === o.name;
      });

      if (fandom) {
        data.push(fandom);
      }
    });

    this.bookmarksData = data;
  },
  watch: {
    bookmarks() {
      const data = [];
      find(this.bookmarks, o => {
        const fandom = find(this.fandoms, fandom => {
          return fandom.name === o.name;
        });

        if (fandom) {
          data.push(fandom);
        }
      });

      this.bookmarksData = data;
    },
    forceExpand(val) {
      this.expand = val;
    }
  },
  computed: {
    ...mapGetters([
      "options",
      "hasPrompts",
      "fandoms",
      "bookmarks",
      "characters",
      "promptmarks",
      "prompts",
      "unlock",
      "loadAll"
    ]),
    marks() {
      const marks = {
        fandoms: this.bookmarks,
        prompts: this.promptsmarks
      };

      return JSON.stringify(marks);
    }
  },
  props: {
    forceExpand: false
  },
  data() {
    return {
      showHelp: false,
      expand: false,
      bookmarksData: [],
      largeBookmarks: false,
      saved: null,
      showLoad: false
    };
  },
  methods: {
    ...utils,
    loadSaved() {
      if (
        !confirm(
          "Are you sure you want to load bookmarks? Your current bookmarks will be wiped!"
        )
      ) {
        return;
      }

      let parsed;

      try {
        parsed = JSON.parse(this.saved);
      } catch (e) {
        alert("Your bookmarks were invalid!");
        return;
      }

      if (!this.saved || !this.saved.length) {
        return;
      }
      this.$localStorage.set(
        "belatedbookmarks",
        JSON.stringify(parsed.fandoms)
      );
      this.$localStorage.set(
        "belatedpromptmarks",
        JSON.stringify(parsed.prompts || [])
      );
      this.$store.commit("setPromptmarks", parsed.prompts || []);
      this.$store.commit("setBookmarks", parsed.fandoms);
    }
  }
};
</script>

<style lang="scss" scoped>
.bookmarks {
  z-index: 2;
  position: fixed;
  top: 50px;
  right: 0;
  padding: 10px;
  padding-top: 30px;
  background: #fafafa;
  width: 60%;
  border: 1px solid #cfcfcf;
  max-height: 600px;
  overflow-y: auto;

  .mobile-expand,
  .expand {
    color: #e74c3c;
    font-size: 20px;
  }

  .title {
    display: inline-block;
    margin: 0;
  }

  .header {
    position: fixed;
    z-index: 2;
    top: 51px;
    padding-top: 10px;
    height: 40px;
    width: 100%;
    background-color: #fafafa;
  }

  &.large {
    width: 95%;
  }

  &.collapsed {
    width: 130px;
    padding-top: 10px;

    .title,
    .expand {
      font-size: 16px;
    }

    .header {
      position: unset;
      height: auto;
      z-index: 0;
    }
  }

  th.fandom {
    width: 250px;
  }

  .letters {
    li {
      padding-left: 10px;
    }
  }

  .options,
  .letters,
  .fandoms {
    margin-top: 10px;
  }

  .counts {
    font-size: 13px;
    margin-left: 22px;
  }

  .remove {
    color: #e74c3c;
    &:hover {
      color: #e4a6a6;
    }
  }

  .show-load {
    cursor: pointer;
  }

  .load-wrapper {
    margin-bottom: 10px;
    display: flex;
    flex-wrap: wrap;
  }

  .load-info {
    flex: 0 0 100%;
  }

  .area {
    flex: 0 0 50%;
    textarea {
      vertical-align: top;
    }
  }

  .load {
    padding: 7px;
    font-weight: bold;
  }
}

@media screen and (max-width: 767px) {
}
</style>
